import React from 'react';
import {Row} from 'react-bootstrap';
import ReportBox from '../elements/ReportBox';
import RequireRole from '../elements/AccessControl/RequireRole';
import Content from '../partials/Content.jsx';

const Reports = () => {
    return (<Content title="Изготвяне на справки и отчети">
        <h5 className="mt-4 mb-2 card-header">Справки</h5>
        <Row className="row-cols-1 row-cols-sm-2 row-cols-xl-4">
            <ReportBox variant="info" type="Справка" description="Издадени полици и сметки за период" icon="tasks"
                       url="/reports/sales" />
            <ReportBox variant="success" type="Справка СБА" description="Издадени СБА карти и сметки за период"
                       icon="life-ring" url="/reports/uab-sales" />
            <ReportBox variant="warning" type="Предстоящи" description="Плащания или изтичащи полици за период"
                       icon="money-bill-1-wave" url="/reports/pending-payments" />
            <RequireRole name="ROLE_BROKER_MANAGER">
            <ReportBox variant="secondary" type="Без вноска" description="Издадени полици без плащане по първа вноска"
                       icon="money-bill-trend-up" url="/reports/without-payments" />
            </RequireRole>
        </Row>
        <h5 className="mt-4 mb-2 card-header">Отчети</h5>
        <Row className="row-cols-1 row-cols-sm-2 row-cols-xl-4">
            <RequireRole name="ROLE_SHOW_COMMISSION">
                <ReportBox variant="success" type="Отчет" description=" към застрахователните компании" icon="clipboard-list"
                           url="/reports/insurance-company" />
            </RequireRole>
            <RequireRole name="ROLE_SALES_REPORT">
                <ReportBox variant="warning" type="Плащания" description="функционален очет за разплащания" icon="rectangle-list"
                           url="/reports/payments" />
            </RequireRole>
            <RequireRole name="ROLE_BROKER_MANAGER">
                <ReportBox variant="info" type="Месечен" description="отчет" icon="fa-regular fa-calendar-check"
                           url="/reports/monthly" />
            </RequireRole>
        </Row>
        <RequireRole name="ROLE_BROKER_MANAGER">
        <h5 className="mt-4 mb-2 card-header">КФН</h5>
        <Row className="row-cols-1 row-cols-sm-2 row-cols-xl-4">
                <ReportBox variant="info" type="Дневник" description="на Застрахователния Брокер" icon="fas fa-book"
                           url="/reports/journal" />
                <ReportBox variant="danger" type="КФН" description="Отчет КФН" icon="building-columns"
                           url="/reports/fsc-report" />
            <ReportBox variant="warning" type="КФН" description="Детайлна справка КФН" icon="list-ol"
                       url="/reports/fsc-info" />
        </Row>
        </RequireRole>
    </Content>);
};

export default Reports;
